import { render, staticRenderFns } from "./addMammal.vue?vue&type=template&id=c7196000&"
import script from "./addMammal.vue?vue&type=script&lang=js&"
export * from "./addMammal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports